import { Platform, View } from 'react-native'
import Gradient from '@ui/effects/Gradient'
import { ButtonProps } from '@ui/buttons/Button/types'
import { colors } from '@ui/colors'
import Icon, { IconName } from '@ui/elements/Icon'
import Typography from '@ui/typography'
import ButtonTheme from '@ui/buttons/ButtonTheme'
import cn from '@ui/utils/cn'
import { widthDefault } from '@ui/theme/values'
import VersionSimpleTag from '@shell/Version/VersionSimpleTag'

interface Props {
  absolute?: boolean
  icon?: IconName
  iconComponent?: React.ReactNode
  title?: string
  desc?: string
  children?: React.ReactNode
  buttons?: ButtonProps[]
}

export default function ScreenTemplate({
  absolute,
  icon,
  iconComponent,
  title,
  desc,
  buttons,
  children,
}: Props) {
  return (
    <View
      className={cn(
        'flex-1 items-center justify-center',
        absolute && 'absolute inset-0 z-50 h-full w-full',
        absolute && Platform.OS === 'web' && 'fixed h-screen w-screen'
      )}
    >
      <Gradient
        colors={[colors.gray[900], colors.black]}
        start={[0.25, 0]}
        end={[0.75, 1]}
      />
      <View
        className="flex w-full flex-col items-center justify-center gap-16 p-16"
        style={{ maxWidth: widthDefault }}
      >
        <View className="flex w-full items-center justify-center gap-8">
          {icon && (
            <View className="flex h-24 w-24 flex-col items-center justify-center">
              <Icon
                name={icon}
                color={colors.white}
                size={64}
                strokeWidth={2}
              />
            </View>
          )}
          {iconComponent}
          <Typography
            variant="H2"
            className="text-center font-text-bold color-white"
          >
            {title}
          </Typography>
          <Typography
            variant="LG"
            className="text-center leading-normal color-white/40"
          >
            {desc}
          </Typography>
        </View>
        {children}
        <View className="flex flex-row items-center justify-center gap-8">
          {buttons?.map((button, index) => (
            <ButtonTheme
              key={index}
              theme="dark"
              variant="outlined"
              size="lg"
              {...button}
            />
          ))}
        </View>
      </View>
      <View className="absolute bottom-8">
        <VersionSimpleTag />
      </View>
    </View>
  )
}
